import { Link } from 'react-router-dom';
import React, { useRef, useState, useContext } from 'react';
import useIntersectionObserver from '../../../hooks/useIntersectionObserver';
import '../../../style.css';

const Intro = ({ dynamicContent }) => {
    const sectionRef = useRef(null);
    const [contentLoaded, setContentLoaded] = useState(false);

    const handleIntersection = () => {
        setContentLoaded(true);
    };

    const isVisible = useIntersectionObserver(sectionRef, handleIntersection);

    return (
        <div ref={sectionRef} className={`loading-container${contentLoaded ? '' : ' loading-spinner-container'}`}>
            {contentLoaded ? (
                <section className={`intro${isVisible ? ' fade-in-observer' : ''}`} id="intro">
                    <div className="intro-content section-content">
                        <p className="section-subtitle">{dynamicContent.ProductName}</p>
                        <h2 className="h3 section-title">{dynamicContent.IntroTitle}</h2>
                        <p className="section-text">{dynamicContent.IntroDescription}</p>
                        <div className="btn-group">
                            <a href={dynamicContent.ProductURL} target='_blank'>Visit Client's Website <ion-icon name="open-outline"></ion-icon>
                                <div className="tooltip">This will open an external site</div>
                            </a>
                        </div>
                    </div>
                    <div className="intro-sub">
                        <div className="Tags">
                            {Array.isArray(dynamicContent.Hashtags) &&
                                dynamicContent.Hashtags.sort((a, b) => a.tag.localeCompare(b.tag))
                                    .map((hashtag, index) => (
                                        <Link to={`/portfolio/tags/${hashtag.tag.replace("#", "")}/`} key={`${hashtag.tag}-${index}`}>
                                            <span className={`tag tag-md ${hashtag.class ? hashtag.class : ''}`}>{hashtag.tag}</span>
                                        </Link>
                                    ))}
                        </div>
                        <div className="role-content section-content">
                            <p className="section-subtitle">My Role</p>
                            <div className="section-text">
                                <ul>
                                    {Array.isArray(dynamicContent.Roles) &&
                                        dynamicContent.Roles.map((role) => <li key={role}>{role}</li>)}
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
            ) : (
                <div className="observer_spinner"></div>
            )}
        </div>
    );
};

export default Intro;
